import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tracker"];
import { useCallback } from 'react';
import { useUsageTrackerContext } from 'personalization-lib/contexts/UsageTrackerContext';
const useTrackEvent = (namespace, eventName) => {
  const _useUsageTrackerConte = useUsageTrackerContext(),
    {
      tracker
    } = _useUsageTrackerConte,
    defaultProperties = _objectWithoutPropertiesLoose(_useUsageTrackerConte, _excluded);
  return useCallback(properties => tracker.track(namespace, eventName, Object.assign({}, properties, defaultProperties)), [tracker, namespace, eventName, defaultProperties]);
};
export default useTrackEvent;